import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './auth-polish.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Caches the app shell on the device so load is instant on repeat visits —
// see serviceWorkerRegistration.js and public/service-worker.js's own
// headers for the full strategy (static assets only, API calls never
// touched).
serviceWorkerRegistration.register();